<!--
versjon basert på at bruker legger til / fjerner chips, kun valgte chips vises
<mat-chip-grid #valgteEntiteterChips>
  @for (entitet of valgteEntiteter(); track entitet.type) {
    <mat-chip-row (removed)="slett(entitet)">
      <span class="kontainer">
        <entitetikon [type]="entitet.entitetType" inline="true"/>
        {{ entitet.navn }}
      </span>
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  }
</mat-chip-grid>

<input placeholder="{{'Type...'|translate}}"
        [formControl]="tekstfilter"
        [matChipInputFor]="valgteEntiteterChips"
        [matAutocomplete]="velgEntiteterListe"
        [matChipInputSeparatorKeyCodes]="tasterSomTriggerLeggTil"
        (matChipInputTokenEnd)="leggTil($event)"
/>
<mat-autocomplete #velgEntiteterListe="matAutocomplete" (optionSelected)="valgt($event)" panelWidth="200px">
  @for (entitet of entiteterForValg(); track entitet.type) {
    <mat-option [value]="entitet">
      <span class="kontainer">
      <entitetikon [type]="entitet.entitetType"/>
      {{ entitet.navn }}
      </span>
    </mat-option>
  }
</mat-autocomplete>-->


<mat-chip-listbox multiple="true" [formControl]="valgte" [compareWith]="erValgt" matTooltip="{{'Velg hvilke typer du vil søke etter'|translate}}" matTooltipPosition="after">
  @for(entitet of tilgjengeligeEntiteter(); track entitet.type){
    <!-- plasserer tooltip over slik at den ikke legger seg over velg-søkeperiode -->
    <!--<mat-chip-option [value]="entitet" [matTooltip]="entitet.hjelpetekst" matTooltipPosition="above">-->
    <mat-chip-option [value]="entitet">
      <span class="kontainer">
        <entitetikon [type]="entitet.entitetType" inline="true"/>
        {{ entitet.navn }}
      </span>
    </mat-chip-option>
  }
</mat-chip-listbox>
